module.exports = __webpack_public_path__ + "static/media/mask_ground_water.db9e68ff.png";